import React from 'react';
import { X, Trash2 } from 'react-feather';
import { useCart } from './CartContext';
import './cart.scss';

// onCheckout is intentionally a prop, not hardcoded here — this drawer
// doesn't know how checkout actually happens (embedded Stripe Checkout
// comes in the next phase). For now it just shows a friendly placeholder
// if no handler has been wired up yet.
export default function CartDrawer({ open, onClose, onCheckout }) {
  const { items, itemCount, subtotal, updateQuantity, removeItem } = useCart();

  const hasUnknownPricing = items.some((i) => typeof i.price !== 'number');

  return (
    <div className={`cart-drawer-overlay ${open ? 'open' : ''}`} onClick={onClose}>
      <aside className="cart-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="cart-drawer-header">
          <h3>Your Cart {itemCount > 0 && <span className="cart-drawer-count">({itemCount})</span>}</h3>
          <button type="button" className="cart-drawer-close" onClick={onClose} aria-label="Close cart">
            <X />
          </button>
        </div>

        {items.length === 0 ? (
          <div className="cart-drawer-empty">
            <p>Your cart is empty.</p>
          </div>
        ) : (
          <div className="cart-drawer-items">
            {items.map((item) => (
              <div className="cart-line" key={item.key}>
                <img src={item.image} alt={item.title} className="cart-line-img" />
                <div className="cart-line-info">
                  <div className="cart-line-title">{item.title}</div>
                  <div className="cart-line-variant">
                    {item.colorLabel}{item.size ? ` · ${item.size}` : ''}
                  </div>
                  <div className="cart-line-qty">
                    <button
                      type="button"
                      onClick={() => updateQuantity(item.key, item.quantity - 1)}
                      aria-label="Decrease quantity"
                    >
                      −
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      type="button"
                      onClick={() => updateQuantity(item.key, item.quantity + 1)}
                      aria-label="Increase quantity"
                    >
                      +
                    </button>
                  </div>
                </div>
                <button
                  type="button"
                  className="cart-line-remove"
                  onClick={() => removeItem(item.key)}
                  aria-label={`Remove ${item.title}`}
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
        )}

        {items.length > 0 && (
          <div className="cart-drawer-footer">
            {!hasUnknownPricing ? (
              <div className="cart-drawer-subtotal">
                <span>Subtotal</span>
                <span>${subtotal.toFixed(2)}</span>
              </div>
            ) : (
              <div className="cart-drawer-subtotal cart-drawer-subtotal--pending">
                Final pricing calculated securely at checkout.
              </div>
            )}
            <button
              type="button"
              className="cart-checkout-btn gradient-color"
              onClick={onCheckout || (() => { window.location.assign('/checkout'); })}
            >
              Checkout
            </button>
          </div>
        )}
      </aside>
    </div>
  );
}
